"use client";

import { cn } from "@/lib/utils";

/**
 * ExplicitBadge — the industry-standard "E" mark (Apple Music / Spotify style):
 * a grey rounded square with a white "E". Shown on tracks flagged explicit.
 * Renders nothing unless `explicit` is true.
 */
export function ExplicitBadge({
  explicit,
  className,
  size = 14,
}: {
  explicit?: boolean | null;
  className?: string;
  /** Square side length in px. */
  size?: number;
}) {
  if (!explicit) return null;
  return (
    <span
      title="Explicit content"
      aria-label="Explicit content"
      className={cn(
        "inline-flex items-center justify-center rounded-[3px] bg-muted-foreground/80 text-background font-bold leading-none flex-shrink-0",
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.72) }}
    >
      E
    </span>
  );
}
